import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_SvgIcon = _resolveComponent("SvgIcon");

  return _openBlock(), _createElementBlock("div", {
    class: "d-flex fl-ae fl-jc",
    onClick: _cache[0] || (_cache[0] = _withModifiers(function ($event) {
      return _ctx.reloadConfig();
    }, ["stop"]))
  }, [_createVNode(_component_SvgIcon, {
    "data-cy": "reload-config-button",
    iconContent: _ctx.iconContent,
    iconAlt: _ctx.iconAlt,
    iconStyle: _ctx.iconStyle,
    class: "reload-config-button"
  }, null, 8, ["iconContent", "iconAlt", "iconStyle"])]);
}